module.exports = __webpack_public_path__ + "static/img_2543-803ed3f8cf31c00436da717d3cc1a678.webp";